import { Component } from '@angular/core';
import { LoaderComponent } from '../../utils/loader/loader.component';
import { CommonModule } from '@angular/common';
import { DevicesService } from '../../services/devices.service';
import { LoginUserModel } from '../../models/loginUserModel';
import { jwtDecode } from 'jwt-decode';
import { FormsModule } from '@angular/forms';
import { MovementsService } from '../../services/movements.service';
import { ResponseTable } from '../../models/ResponseTable';
import { CustomButton } from '../../models/customButton';
import { CardComponent } from '../../utils/card/card.component';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { PaginatorComponent } from '../../utils/paginator/paginator.component';
import { CustomTableIconComponent } from '../../utils/custom-table-icon/custom-table-icon.component';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { CustomTableComponent } from "../../utils/custom-table/custom-table.component";
import { ToastService } from '../../services/toast.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-station-assignment',
    imports: [
        LoaderComponent,
        CommonModule,
        FormsModule,
        NgxPaginationModule,
        CustomTableIconComponent,
        CustomTableComponent,
        ButtonModule,
        InputTextModule,
        SelectButtonModule,
        IconFieldModule,
        InputIconModule,
        TableModule,
        TooltipModule
    ],
    templateUrl: './station-assignment.component.html',
    styleUrl: './station-assignment.component.scss'
})
export class StationAssignmentComponent {
  isLoader: boolean = false;
  msgError: string = '';
  data!: LoginUserModel;
  tableData: any[] = [];
  filteredTable: any[] = [];
  searchText = '';
  options: any[] = [];
  dataResult: any[] = [];
  _drivers: any[] = [];
  isChoice: boolean = false;
  response: ResponseTable = new ResponseTable();
  tableButtons: CustomButton[] = [];
  statusFilter = 'X';
  viewModes = [
    { label: 'Por Cliente', value: 'X' },
    { label: 'Por Tarjeta', value: 'T' },
    { label: 'Por Grupo', value: 'C' }
  ];
  public configTable: PaginationInstance = {
    id: 'idPag',
    itemsPerPage: 12,
    currentPage: 1,
  };
  restrictionType: number = 2;
  sendResponse: any;
  isBack: boolean= false
  messageModal: string = '';

  constructor(private services: DevicesService, private srv: MovementsService, private titleService:Title, private themeService:ThemeService, private toastSrv: ToastService
      
  ) {
    this.titleService.setTitle("Estaciones - Asignación");
    this.themeService.setTitle("Asignación de estaciones");
 
    this.data = JSON.parse(localStorage.getItem('data')!); 
    this.tableButtons = [
      {
        text: 'Ubicación',
        action: (event: any) => this.showInfoMaps(event),
        icon: 'map-pin' as any,
        hasIcon: true,
        color: '',
        showText: false,
      }
    ];
    this.sendResponse = {
      clientNumber: this.data.Client_number,
      clientId: this.data.Client_id,
      type: 2,
      id: 0,
      title:''
    };
  }

  ngOnInit() {
    this.responseInfo(0);
  }

  loadDevices() {
    this.isLoader = true;
    this.services
      .loadDevices(this.data.Client_number, this.data.User_id, '')
      .subscribe({
        next: (resp: any) => {
          this.tableData = resp;
          this.filteredTable = this.tableData;
          this.isLoader = false;
        },
        error: (err: any) => {
          this.toastSrv.add({ type: 'error', message: err.message }); this.isLoader = false
        }
      });
  }

  loadGroup() {
    this.isLoader = true;
    this.srv.getGroup(this.data.Client_id).subscribe({
      next: (resp: any) => {
        this.tableData = resp.response.map((item: any) => {
          return { ...item, card_id: item.groupId };
        });
        this.filteredTable = this.tableData;
        this.isLoader = false;
      },  error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.message }); this.isLoader = false
      }
    });
  }

  searchByText(event: any) {
    const searchText = event.target.value.toLowerCase();
    this.filteredTable = this.tableData.filter((item) => {
      const vehicleFullNumber =
        item.vehicleFullNumber?.toString().toLowerCase() || '';
      const description = item.description?.toString().toLowerCase() || '';
      const nameUser = item.nameUser?.toString().toLowerCase() || '';
      return (
        vehicleFullNumber.includes(searchText) ||
        description.includes(searchText) ||
        nameUser.includes(searchText)
      );
    });
    this.configTable.currentPage = 1;
  }

  saveStation(data: any[]) {

    this.srv.saveStation(data).subscribe({
      next: (resp: any) => {
        if (resp.message == '') {
          this.getStations(this.sendResponse);
        } else {
          this.toastSrv.add({ type: 'success', message: resp.mensaje }); this.isLoader = false; this.backButton()
        }
      },
      error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.message }); this.isLoader = false
      }
    });
  } 

  select(data: any) {
    if (data.type == 0) {
      data.type = 2;
    } else if (data.type == 1) {
      data.type = 4;
    } else if (data.type == 2) {
      data.type = 0;
    } else if (data.type == 4) {
      data.type = 1;
    }
  }

  deleteStation(data: any) {
    this.srv.deleteStation(data).subscribe({
      next: (resp: any) => {
        if (resp.message == '') {
           this.getStations(this.sendResponse);
        } else {
          this.messageModal = resp.message
        }
      },  error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.message }); this.isLoader = false
      }
    });
  }

  update() {
    let saveData = this.dataResult.filter((item) => item.type === 2);
    const deletefilter = this.dataResult.filter((item) => item.type === 4);
    if (saveData.length > 0) {
      this.isLoader = true
      saveData = saveData.map((item: any) => {
        return {
          restrictionId: item.id,
          clientNumber: this.data.Client_number,
          cardNumber: this.sendResponse.id,
          parentName: this.data.User_id == 0 ? 'Administrador de la cuenta' : this.data.Name,
          parentId: this.data.Client_id,
          stationNumber: item.number,
          stationName: item.commercialName,
          restrictionType: this.sendResponse.type,
        };
      });
      this.saveStation(saveData);
    }
    
    if (deletefilter.length > 0) {
      this.isLoader = true
      const deleteData = {
        clientNumber: this.data.Client_number,
        name: this.data.User_id == 0 ? 'Administrador de la cuenta' : this.data.Name,
        type: this.sendResponse.type,
        item: this.sendResponse.id.toString(),
        restrictionId: deletefilter.map((item: any) => item.id),
        stationDescription: deletefilter.map(
          (item: any) => item.commercialName
        ),
        groupDescription:this.sendResponse.type==1?this.sendResponse.title:'' ,
      };
      this.deleteStation(deleteData)
    }  
  }

  cancel() {
    this.isChoice = false;
    this.dataResult = [];
    this.searchText = '';
    this.getStations(this.sendResponse);
  }

  selectData() {
    this.isBack=false;
    this.dataResult = [];
    this.searchText = '';
    if (this.statusFilter == 'X') {
      this.responseInfo(0);
    } else if (this.statusFilter == 'T') {
      this.isChoice = false;
      this.loadDevices();
    } else if (this.statusFilter == 'C') {
      this.isChoice = false;
      this.loadGroup();
    }
  }

  responseInfo(data: any) {
    if (this.data.UserType == 'Administrator' || this.data.UserType == 'Modify') {
    
    if (this.statusFilter == 'X') {
      this.sendResponse.type = 2;
      this.sendResponse.id = 0;   
      this.sendResponse.title = '';    
    } else if (this.statusFilter == 'T') {
      this.isBack= true;
      this.sendResponse.type = 0;
      this.sendResponse.id = data.vehicleFullNumber.split('-')[3];
      this.sendResponse.title = data.vehicleFullNumber;     
    } else if (this.statusFilter == 'C') {
      this.isBack= true;
      this.sendResponse.type = 1;
      this.sendResponse.id = data.card_id;
      this.sendResponse.title = data.description;    
    }
  }
    this.getStations(this.sendResponse);
  
  }
  getStations(data: any) {
    this.isLoader = true;
    this.isChoice = true;
    this.srv.getStation(data).subscribe({
      next: (resp: any) => {
        if (resp.message == '') {

          const modifiedResponseA = resp.response.a.items.map((item: any) => {
            return { ...item, type: 0 };
          });
          const modifiedResponseB = resp.response.b.items.map((item: any) => {
            return { ...item, type: 1 };
          });
          this.response.items = modifiedResponseB.concat(modifiedResponseA);
          if (this.data.UserType == 'Administrator' || this.data.UserType == 'Modify') {
            this.response.headers = resp.response.b.headers;
          }else{
            this.response.headers = resp.response.b.headers.filter((e:any)=>e.textHeader!='Todo');
          }
          this.response.title = resp.response.b.title;
        } else {
          this.messageModal = resp.message
        }
        this.dataResult = []
        this.isLoader = false;
      },   error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: err.message }); this.isLoader = false
      }
    });
  }

  showInfoMaps(data: any) {
    const query = encodeURIComponent(data.map || '');
    window.open('https://www.google.com/maps/search/?api=1&query=' + query, '_blank');
  }

  resultData(data: any) {
    if (this.data.UserType == 'Administrator' || this.data.UserType == 'Modify') {
    const activeSave = data.filter((item: { type: number; }) => item.type === 2 ||item.type === 4);
    if(activeSave.length > 0){
      this.dataResult = data;
    }
    else{
      this.dataResult = []      
    }
  }
  }
  backButton(){
    this.isChoice = false;
    this.searchText = '';
    this.selectData();
  }
}
